---
title: "Do Something Amateur Radio Club Bylaws"
adopted: 2024-01-01
updated: 2024-01-01
---

# Do Something Amateur Radio Club (DSARC) Bylaws

## Article I: Governance

### Section 1: Authority
The Do Something Amateur Radio Club (DSARC) operates as a program under Do Something Amateur Radio Club, Inc. (DSARC, Inc.). The board of directors of DSARC, Inc. retains final authority and oversight of all DSARC activities, including budget approval, officer elections, and policy setting.

### Section 2: Officers
The officers of DSARC shall be:
- **President**: Presides over meetings and represents the club in all matters.
- **Vice-President**: Assists the President and assumes their duties in their absence.
- **Secretary**: Maintains meeting minutes and club records.
- **Treasurer**: Manages the financial operations and reports to the club membership and DSARC, Inc.

Officers shall be elected annually by the voting membership and reported to the DSARC, Inc. board of directors for acknowledgment. Vacancies may be filled temporarily by the board of directors until the next election.

### Section 3: Quorum
- A quorum for voting on club matters shall consist of **50% of voting members** present at a meeting.
- **If quorum is not met**, the board of directors of DSARC, Inc. may act on behalf of the membership to ensure continuity of operations. Actions taken by the board in the absence of quorum must be communicated to the membership at the next regular meeting and recorded in the minutes.

### Section 4: Voting
- Only **dues-paying members** with valid amateur radio licenses shall have voting privileges.
- Decisions shall pass by a **majority vote** of voting members present.

---

## Article II: Membership

### Section 1: Eligibility
Membership in DSARC is open to anyone interested in amateur radio. Membership categories are:
- **Voting Members**: Licensed amateur radio operators who have paid their dues.
- **Non-Voting Members**: Individuals without licenses, including family members, students, and those supporting the club’s mission.

### Section 2: Dues
Membership dues are:
- **$40/year** for voting members.
- **$20/year** for members under 18 or college students under 26.
- **$80/year** for families (up to 4 call signs within the same household).

Dues are payable annually on January 1st. Non-payment of dues within 3 months results in loss of voting rights.

---

## Article III: Meetings

### Section 1: Regular Meetings
Regular meetings of DSARC shall occur at least once per month. The time and place shall be determined by club leadership and communicated to members at least 7 days in advance.

### Section 2: Special Meetings
Special meetings may be called by the President, the board of directors of DSARC, Inc., or upon request of 25% of voting members. Members must be notified at least 7 days in advance.

### Section 3: Meeting Records
The Secretary shall keep accurate minutes of all meetings, which shall be available to members upon request. Minutes and actions shall also be shared with the DSARC, Inc. board of directors.

---

## Article IV: Financial Management

### Section 1: General Fund
All funds received from membership dues, fundraising, or donations shall be deposited into the **general fund** managed by DSARC, Inc.

### Section 2: Program Budgets
The board of directors of DSARC, Inc. shall allocate funds from the general fund to DSARC based on approved budgets. Donations with a specific purpose noted (memo) shall be earmarked for that purpose.

### Section 3: Reporting
The Treasurer shall maintain accurate financial records and provide regular financial reports to the club membership and the board of directors of DSARC, Inc.

---

## Article V: Committees

### Section 1: Creation of Committees
The board or club leadership may establish committees for specific purposes, such as event planning or public service activities. Each committee shall have a chairperson appointed by the President or the board.

### Section 2: Committee Reporting
Committees shall report their activities and recommendations to the club leadership and DSARC, Inc. when required.

---

## Article VI: Amendments

These bylaws may be amended by a **two-thirds majority vote** of voting members present at a regular meeting, provided that notice of the proposed amendment is given to members at least 14 days in advance. Amendments must be submitted to the board of directors of DSARC, Inc. for final approval.

---

## Article VII: Oversight and Alignment

### Section 1: Oversight
The DSARC board of directors shall retain oversight of the club’s governance, officer elections, and finances to ensure alignment with the nonprofit's mission and bylaws.

### Section 2: Compliance
The club shall operate within the policies and procedures set forth by DSARC, Inc., including financial management, reporting, and use of resources.

---
